<div class="text-panel__content">
  <div class="text-panel__tools">
    <div class="text-panel__font">
      <select class="text-panel__select" (change)="setFont($event.target.value)">
        <option *ngFor="let font of fonts" [value]="font.css" [selected]="asTextLayerData(layerData)?.font == font.css">{{ font.name }}</option>
      </select>
    </div>
    <div class="text-panel__options">
      <div class="font-size">
      <select class="text-panel__select" (change)="setSize(+$event.target.value)">
        <option value="8" [selected]="asTextLayerData(layerData)?.size == 8">8</option>
        <option value="9" [selected]="asTextLayerData(layerData)?.size == 9">9</option>
        <option value="10" [selected]="asTextLayerData(layerData)?.size == 10">10</option>
        <option value="11" [selected]="asTextLayerData(layerData)?.size == 11">11</option>
        <option value="12" [selected]="asTextLayerData(layerData)?.size == 12">12</option>
        <option value="14" [selected]="asTextLayerData(layerData)?.size == 14">14</option>
        <option value="16" [selected]="asTextLayerData(layerData)?.size == 16">16</option>
        <option value="18" [selected]="asTextLayerData(layerData)?.size == 18">18</option>
        <option value="20" [selected]="asTextLayerData(layerData)?.size == 20">20</option>
        <option value="22" [selected]="asTextLayerData(layerData)?.size == 22">22</option>
        <option value="24" [selected]="asTextLayerData(layerData)?.size == 24">24</option>
        <option value="26" [selected]="asTextLayerData(layerData)?.size == 26">26</option>
        <option value="28" [selected]="asTextLayerData(layerData)?.size == 28">28</option>
        <option value="36" [selected]="asTextLayerData(layerData)?.size == 36">36</option>
        <option value="48" [selected]="asTextLayerData(layerData)?.size == 48">48</option>
        <option value="72" [selected]="asTextLayerData(layerData)?.size == 72">72</option>
      </select>
      <input type="text" class="text-panel__input" [value]="asTextLayerData(layerData)?.size ? asTextLayerData(layerData).size : '8'" (keyup)="setSize(+$event.target.value)" />

    </div>

      <span class="text-panel__aspect">
        <button class="icon-button" (click)="setBold(!asTextLayerData(layerData)?.bold)" [disabled]="!hasBold"><span class="icon icon-bold"></span></button>
        <button class="icon-button" (click)="setItalic(!asTextLayerData(layerData)?.italic)" [disabled]="!hasItalic"><span class="icon icon-italic"></span></button>
        <button class="icon-button" (click)="setUnderline(!asTextLayerData(layerData)?.underline)"><span class="icon icon-underline"></span></button>
      </span>
    </div>
    <div class="text-panel__align">
      <button class="icon-button" (click)="setAlign('left')" [disabled]="asTextLayerData(layerData)?.align == 'left' || asTextLayerData(layerData)?.locks.position"><span class="icon icon-align-to-left"></span></button>
      <button class="icon-button" (click)="setAlign('center')"
        [disabled]="asTextLayerData(layerData)?.align == 'center' || asTextLayerData(layerData)?.locks.position"><span class="icon icon-center-text-alignment"></span></button>
      <button class="icon-button" (click)="setAlign('right')" [disabled]="asTextLayerData(layerData)?.align == 'right' || asTextLayerData(layerData)?.locks.position"><span class="icon icon-align-to-right"></span></button>
    </div>
    <div class="text-panel__lineheight">
      <button class="icon-button" (click)="setLeading(asTextLayerData(layerData)?.leading + 1)"><span class="icon icon-line-height-plus"></span></button>
      <button class="icon-button" (click)="setLeading(asTextLayerData(layerData)?.leading - 1)"><span class="icon icon-line-height-minus"></span></button>
    </div>
  </div>
  <div class="text-panel__actions">
    <button class="text-button"  (click)="addTextLayer()"><span class="text-button__icon icon icon-round-add-button"></span><span
        class="text-button__label">{{ 'cfg_textPanel_title' | translate }}</span></button>
    <button class="text-button"  (click)="addFont()"><span class="text-button__icon icon icon-download"></span><span
        class="text-button__label">{{ 'cfg_textPanel_import' | translate }}</span></button>
  </div>
</div>


<app-modal id="modal-font-upload" width="750" [blocking]="true" #mfu>
    <ng-container *ngIf="(fontImportStep === 1) && (fontErrorRef == '') && (fontProgressRef == '')">
        
      <p [innerHtml]="'cfg_textPanel_alertOSsecurity' | translate"></p>
  
        <div class="modal__buttons">
          <button class="button--outline button--square" (click)='mfu.close()'>
            <span>{{ 'btn_cancel' | translate }}</span>
          </button>
          <button class="button button--square" (click)="browseFont()">
              <span>{{ 'btn_parcourir' | translate }}</span>
          </button>
        </div>

    </ng-container>
  
  
    <ng-container *ngIf="fontErrorRef != ''">
        <p [innerHtml]="fontErrorRef | translate"></p>
  
        <div class="modal__buttons">
          <button class="button button--square" (click)="fontErrorRef = ''">
            <span>{{ 'btn_ok' | translate }}</span>
          </button>
        </div>
     </ng-container>
  
     <ng-container *ngIf="fontProgressRef != ''">
        <p [innerHtml]="fontProgressRef | translate"></p>
     </ng-container>
  
  </app-modal>